export const accountTypes = [
    {
        name: 'Free',
        type: 'free'
    },
    // {
    //     name: 'Free-15 Beginner',
    //     type: 'F15B'
    // },
    {
        name: 'Beginner',
        type: 'beginner'
    },
    {
        name:'Developer',
        type:'developer'
    },
    // {
    //     name: 'Premium Admin-15 Beginner',
    //     type: 'PA-15B'
    // },
    // {
    //     name: 'Premium Admin-30 Beginner',
    //     type: 'PA-30B'
    // },
    // {
    //     name: 'Premium Admin-60 Beginner',
    //     type: 'PA-60B'
    // },
    // {
    //     name: 'Premium Admin-160 Beginner',
    //     type: 'PA-160B'
    // },
    {
        name: 'Suspend',
        type: 'Suspend'
    },
    {
        name:'Expired',
        type:'expired'
    },
    // {
    //     name: 'Partner Beginner',
    //     type: 'partner-beginner'
    // },
];

export const accountTypeEdit = [
    {
        name: 'Free',
        type: 'free'
    },
    {
        name: 'Beginner',
        type: 'beginner'
    },
    {
        name:'Developer',
        type:'developer'
    },
    {
        name: 'Suspend',
        type: 'Suspend'
    },
    {
        name:'Expired',
        type:'expired'
    }
];

export const accountTypesEditAdmin = [
    {
        name: 'Free-15 Beginner',
        type: 'F15B'
    },
    {
        name: 'Premium Admin-15 Beginner',
        type: 'PA-15B'
    },
    {
        name: 'Premium Admin-30 Beginner',
        type: 'PA-30B'
    },
    {
        name: 'Premium Admin-60 Beginner',
        type: 'PA-60B'
    },
    {
        name: 'Premium Admin-160 Beginner',
        type: 'PA-160B'
    },
    {
        name: 'Suspend',
        type: 'Suspend'
    },
    {
        name:'Expired',
        type:'expired'
    },
    {
        name: 'Partner Beginner',
        type: 'partner-beginner'
    },
];